import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  card: {
    width: '100%',
    borderRadius: 8,
    background: theme.palette.grey[200],
    margin: '8px 0 16px',
    padding: theme.spacing(2)
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(1)
  },
  icon: {
    color: theme.palette.secondary.main
  },
  title: {
    color: theme.palette.text.primary,
    fontWeight: 600,
    overflowWrap: 'anywhere'
  },
  message: {
    color: theme.palette.grey[700],
    lineHeight: 1.8
  },
  warning: {
    color: theme.palette.warning.dark
  },
  success: {
    color: theme.palette.secondary.main,
    fontWeight: 600
  },
  promotion: {
    background: theme.palette.background.paper,
    borderRadius: 6,
    padding: theme.spacing(1.5),
    marginTop: theme.spacing(1)
  },
  row: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: theme.spacing(1),
    marginTop: theme.spacing(0.5)
  },
  details: {
    flex: '1 1 160px',
    minWidth: 0
  },
  amount: {
    whiteSpace: 'nowrap',
    color: theme.palette.secondary.main,
    fontWeight: 600
  },
  allocation: {
    color: theme.palette.grey[700],
    fontSize: 12
  },
  divider: {
    margin: `${theme.spacing(1)}px 0`
  }
}))

export default useStyles
